import React from 'react';

const GlobalRadar = ({ label }) => {
  // Random blip coordinates for scanning effect
  const blips = [
    { top: '35%', left: '42%', delay: '0.2s' },
    { top: '65%', left: '72%', delay: '1.5s' },
    { top: '45%', left: '25%', delay: '2.1s' },
    { top: '25%', left: '65%', delay: '0.8s' },
    { top: '55%', left: '55%', delay: '2.7s' },
  ];

  return (
    <div className="relative w-full max-w-[600px] aspect-square mx-auto bg-[#020a0d] border border-sonar-green/30 p-4 font-mono overflow-hidden rounded-xl shadow-[0_0_40px_rgba(46,204,113,0.1)]">
      {/* Background Grid Lines */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(46,204,113,0.15)_1px,transparent_1px),linear-gradient(90deg,rgba(46,204,113,0.15)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>

      {/* World Map Mask (Continents) */}
      <div className="absolute inset-0 bg-sonar-green pointer-events-none" style={{
        WebkitMaskImage: "url('https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg')",
        WebkitMaskSize: "85%",
        WebkitMaskPosition: "center",
        WebkitMaskRepeat: "no-repeat",
        opacity: 0.2
      }}></div>

      {/* Concentric Radar Rings */}
      <div className="absolute inset-8 rounded-full border border-sonar-green/40 shadow-[0_0_30px_rgba(46,204,113,0.15)_inset] pointer-events-none"></div>
      <div className="absolute inset-[25%] rounded-full border border-sonar-green/30 pointer-events-none"></div>
      <div className="absolute inset-[40%] rounded-full border border-sonar-green/20 pointer-events-none"></div>
      <div className="absolute inset-[55%] rounded-full border border-sonar-green/10 pointer-events-none"></div>

      {/* Crosshairs */}
      <div className="absolute top-8 bottom-8 left-1/2 w-[1px] bg-sonar-green/40 pointer-events-none"></div>
      <div className="absolute left-8 right-8 top-1/2 h-[1px] bg-sonar-green/40 pointer-events-none"></div>

      {/* Animated Ping Blips */}
      {blips.map((blip, i) => (
        <div key={i} className="absolute w-2.5 h-2.5 bg-sonar-green rounded-full shadow-[0_0_15px_#2ecc71] animate-ping"
             style={{ top: blip.top, left: blip.left, animationDelay: blip.delay, animationDuration: '3s' }}></div>
      ))}

      {/* Rotating Radar Sweep */}
      <div className="absolute inset-8 rounded-full overflow-hidden pointer-events-none">
        <div className="w-full h-full animate-[spin_3s_linear_infinite]"
             style={{ background: 'conic-gradient(from 0deg, transparent 70%, rgba(46,204,113,0.15) 98%, rgba(46,204,113,0.8) 100%)' }}>
          {/* Leading Edge Line */}
          <div className="absolute left-1/2 top-0 bottom-1/2 w-[2px] bg-sonar-green shadow-[0_0_15px_#2ecc71] origin-bottom -translate-x-1/2"></div>
        </div>
      </div>

      {/* Overlay Technical Text */}
      <div className="absolute top-4 left-4 text-sonar-green/70 text-[10px] hidden sm:block">
        TGT_ACQ: {Math.random().toString(36).substring(2, 8).toUpperCase()}<br/>
        SYS_STAT: OPTIMAL
      </div>
      <div className="absolute bottom-4 right-4 text-sonar-green/70 text-[10px] text-right hidden sm:block">
        LAT: 34.0522 N<br/>
        LNG: 118.2437 W
      </div>

      {/* Dynamic Status Label */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 whitespace-nowrap bg-[#020a0d]/90 px-6 py-2 border border-sonar-green/50 rounded-full text-sonar-green text-xs md:text-sm font-bold tracking-widest animate-pulse backdrop-blur shadow-[0_0_15px_rgba(46,204,113,0.2)]">
        {label}
      </div>
    </div>
  );
};

export default GlobalRadar;